var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('entity-type-image');
import { breakpoints, theme } from '@shapeable/theme';
import { EntityTypeIcon } from './entity-type-icon';
export var EntityTypeImageDefaultProps = {
  iconColor: 'textTag',
  aspectRatio: {
    base: 16 / 9
  },
  iconSize: 300,
  bgColor: 'text'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  \n  ", "\n\n  ", "\n  "], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  \n  ", "\n\n  ", "\n  "])), function (_a) {
    var bgColor = _a.bgColor;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n  "], ["\n    background: ", ";\n  "])), theme.COLOR(bgColor));
  }, function (props) {
    return props.aspectRatio && props.aspectRatio.base && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.base * 100);
  }),
  landscape: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.aspectRatio && props.aspectRatio.landscape && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.landscape * 100);
  }),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.aspectRatio && props.aspectRatio.tablet && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.tablet * 100);
  }),
  desktop: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.aspectRatio && props.aspectRatio.desktop && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.desktop * 100);
  }),
  desktopLarge: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.aspectRatio && props.aspectRatio.desktopLarge && css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.desktopLarge * 100);
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  "], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    overflow: hidden;\n  "], ["\n    overflow: hidden;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Icon: styled(EntityTypeIcon)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var EntityTypeImage = function EntityTypeImage(props) {
  var className = props.className,
      entityTypeName = props.entityTypeName,
      iconColor = props.iconColor,
      iconSize = props.iconSize,
      bgColor = props.bgColor,
      aspectRatio = props.aspectRatio;
  return React.createElement(My.Container, {
    bgColor: bgColor,
    aspectRatio: aspectRatio,
    className: cls.name(className)
  }, React.createElement(My.Body, null, React.createElement(My.Icon, {
    size: iconSize,
    entityTypeName: entityTypeName,
    color: iconColor
  })));
};
EntityTypeImage.defaultProps = EntityTypeImageDefaultProps;
EntityTypeImage.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;